'use strict';

var series = require('async/series');

var _require = require('./utils'),
    toSources = _require.toSources;

var cp = require('./cp');

var rm = require('./rm');

var defaultOptions = {
  parents: false,
  recursive: false,
  flush: true,
  format: 'dag-pb',
  hashAlg: 'sha2-256'
};

module.exports = function (ipfs) {
  return function mfsMv() {
    var args = Array.from(arguments);

    if (Array.isArray(args[0])) {
      args = args[0].concat(args.slice(1));
    }

    var _toSources = toSources(args, defaultOptions),
        sources = _toSources.sources,
        options = _toSources.options,
        callback = _toSources.callback; // remove the callback


    var cpArgs = sources.map(function (source) {
      return source.path;
    }).concat(options); // remove the last source as it'll be the destination

    var rmArgs = sources.slice(0, -1).map(function (source) {
      return source.path;
    }).concat(Object.assign(options, {
      recursive: true
    }));
    series([function (cb) {
      return cp(ipfs).apply(null, cpArgs.concat(cb));
    }, function (cb) {
      return rm(ipfs).apply(null, rmArgs.concat(cb));
    }], callback);
  };
};